import { get } from 'lodash';

export const getAdvertsSetup = (state) => get(state, 'pageInfo.advertsSetup', false);
